import { ConfigProvider, Flex } from 'antd';
import { DrawingSetPage, InspectorWrapper, store } from '@sitemax/smx-drawings-web';
import { Provider } from 'react-redux';
import { useAppSelector } from '../../../../utilities/hooks';
import React from 'react';

const DrawingSetWrapperPage = () => {
    const globalFilterProject = useAppSelector((state) => state.app.globalFilterProject);

    return (
        <Flex vertical style={{ minWidth: 0, height: 'calc(100vh - 162px)' }}>
            <Flex justify={'space-between'} style={{ height: 'calc(100% - 20px)' }}>
                <Provider store={store}>
                    <ConfigProvider
                        theme={{
                            components: {
                                Collapse: {
                                    headerPadding: '12px 16px',
                                },
                                Tabs: {
                                    horizontalMargin: '0 0 16px 0',
                                },
                            },
                        }}
                    >
                        <DrawingSetPage />
                        <InspectorWrapper filterProject={globalFilterProject} />
                    </ConfigProvider>
                </Provider>
            </Flex>
        </Flex>
    );
};

export default DrawingSetWrapperPage;
